module.exports = __webpack_public_path__ + "img/Weapon_224.10f6c5ce.png";